import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 6.02v3.73h3.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 4.75c4.01 0 7.25 3.24 7.25 7.25s-3.24 7.25-7.25 7.25S4.75 16.01 4.75 12m.34-2.2C6.02 6.88 8.77 4.75 12 4.75"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.5 19.86A8.25 8.25 0 0020.25 12m-17-6.5v4.25H7.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 3.75c4.56 0 8.25 3.69 8.25 8.25 0 4.56-3.69 8.25-8.25 8.25-4.56 0-8.25-3.69-8.25-8.25m.39-2.5A8.25 8.25 0 0112 3.75"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 7.5c9.12 0 16.5 7.38 16.5 16.5 0 9.12-7.38 16.5-16.5 16.5-9.12 0-16.5-7.38-16.5-16.5m.78-5C10.38 12.34 16.64 7.5 24 7.5"
  }))
};
export var Replay = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});